//ecd:-879450193H20261022084009_V3.0

/**
 * Address
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
export interface Address {

    street1: string;
    
    street2?: string;
    
    city: string;
    
    state?: string;
    
    zipcode: string;
    
    countryCode: string;
}

/** Each field's label and limits, as the DSL declares them. */
export const AddressFields = {
    street1: { label: "street1", required: true, maxLength: 50 },
    street2: { label: "street2", maxLength: 50 },
    city: { label: "city", required: true, maxLength: 50 },
    state: { label: "state", maxLength: 50 },
    zipcode: { label: "zipcode", required: true, maxLength: 10 },
    countryCode: { label: "countryCode", required: true, maxLength: 2 },
} as const;

/**
 * The DSL's checks, before sending: field -> message, empty when nothing is
 * wrong. The server checks them again; this is so a form can say it first.
 * partial: an update that sends only what changed - what is required is not asked for.
 */
export function validateAddress(value: Partial<Address> | null | undefined, partial = false): Record<string, string> {
    const errors: Record<string, string> = {};
    if (value == null) return errors;
    if (partial ? value.street1 === '' : (value.street1 == null || value.street1 === '')) errors.street1 = "street1 is required";
    else if (value.street1 != null && String(value.street1).length > 50) errors.street1 = "street1 is at most 50 characters";
    if (value.street2 != null && String(value.street2).length > 50) errors.street2 = "street2 is at most 50 characters";
    if (partial ? value.city === '' : (value.city == null || value.city === '')) errors.city = "city is required";
    else if (value.city != null && String(value.city).length > 50) errors.city = "city is at most 50 characters";
    if (value.state != null && String(value.state).length > 50) errors.state = "state is at most 50 characters";
    if (partial ? value.zipcode === '' : (value.zipcode == null || value.zipcode === '')) errors.zipcode = "zipcode is required";
    else if (value.zipcode != null && String(value.zipcode).length > 10) errors.zipcode = "zipcode is at most 10 characters";
    if (partial ? value.countryCode === '' : (value.countryCode == null || value.countryCode === '')) errors.countryCode = "countryCode is required";
    else if (value.countryCode != null && String(value.countryCode).length > 2) errors.countryCode = "countryCode is at most 2 characters";
    return errors;
}
